/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import PaginatedListState, { type PaginatedListParams } from 'flarum/common/states/PaginatedListState';
import type User from 'flarum/common/models/User';

export default class HomeActivityLeaderboardState extends PaginatedListState<User> {
	constructor(params?: PaginatedListParams, page?: number, pageSize?: number) {
		super(params, page, pageSize);
	}

	get type(): string {
		return 'of/active_users';
	}
}
